import React from 'react';
import Navbar from '../components/Navbar';
import BackgroundImage from '../components/BackgroundImage';
import Study_Material from '../components/Study_Material';
import './Home.css'; // Import your CSS file for styling

const Home = () => {
  return (
    <>
      <Navbar />


      <BackgroundImage />


      <Study_Material />
    </>
  );
};

export default Home;
